import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import { FieldWrapper, Input, Text } from 'components';
import { theme, toRem } from 'design';

interface InputCharCounterProps {
  countMax: number;
  maxLength?: number;
  onInputChange?: (inputValues: { value: string; error: boolean }) => void;
}

interface InputCharCounterStyleProps extends InputCharCounterProps {
  charCount: number;
}

const Layout = styled.div<InputCharCounterStyleProps>`
  padding: ${toRem(22)};
  background: ${theme.color.neutral[100]};
  border-radius: ${toRem(theme.borderRadius.small)};
  width: 100%;

  .character-counter {
    color: ${({ charCount, countMax }) => (charCount > countMax ? theme.color.danger.medium : theme.color.neutral[700])};
    padding-top: ${toRem(8)};
  }
`;

const InputCharCounter: React.FC<InputCharCounterProps> = ({ countMax, maxLength, onInputChange }) => {
  const [charCount, setCharCount] = useState(0);

  const handleChange = (newVal: string) => {
    setCharCount(newVal.length);
    if (onInputChange) onInputChange({ value: newVal, error: newVal.length > countMax });
  };

  const debounceInputChange = debounce(handleChange, 300);

  return (
    <Layout charCount={charCount} countMax={countMax} data-cy="input-char-counter">
      <FieldWrapper label="Reason for Canceling">
        <Input maxLength={maxLength} onChange={(e) => debounceInputChange(e.currentTarget.value)} />
        <Text size="xxsmall" className="character-counter">
          {charCount}/{countMax}
        </Text>
      </FieldWrapper>
    </Layout>
  );
};

export default InputCharCounter;
